import React from 'react'
import links from 'links'
import cx from 'classnames'
import config from 'config'
import { useDevice } from 'device'
import loadable from '@loadable/component'
import { useModuleTitle } from 'models/settings'

import HeaderButton from 'src/components/inputs/buttons/HeaderButton/HeaderButton'

import { Bone } from 'components/layout'
import { Href } from 'components/navigation'
import { Text } from 'components/dataDisplay'

import 'leaflet/dist/leaflet.css'


const VgdTransportMap = loadable(() => import('./components/VgdTransportMap/VgdTransportMap'), {
  ssr: false,
  fallback: (<Bone h={280} />),
})

const TransportMap = loadable(() => import('layers/publicTransport/pages/HomePage/components/TransportMap/TransportMap'), {
  ssr: false,
  fallback: (<Bone h={280} />),
})


type TransportBlockProps = {
  className?: string
}

const TransportBlock: React.FC<TransportBlockProps> = (props) => {
  const { className } = props
  const { isMobile } = useDevice()

  const linkToTransport = config.cityName === 'Волгодонск' ? links.transport.root : links.transport.root

  const { title } = useModuleTitle('PUBLIC_TRANSPORT')
  return (
    <div className={cx(className)}>
      <HeaderButton
        title={title}
        size={isMobile ? 'h20-24' : 'h32'}
        to={linkToTransport}
      />
      <Text
        className="mt-16px opacity-72"
        message="Прогнозы прибытия городского транспорта, расписание, остановки и маршруты"
        size="t16-24"
        color="gladiator"
      />
      <Href to={linkToTransport}>
        <div className="mt-32px overflow-hidden relative pointer" style={{ height: `280px` }}>
          {
            config.cityName === 'Волгодонск' ? (
              <VgdTransportMap/>
            ) : (
              <TransportMap
                className="radius-24 overflow-hidden w-full h-full absolute pointer"
                isRoadsActive={false}
                zoom={14}
                scrollWheelZoom={false}
                zoomControl={false}
                doubleClickZoom={false}
                whenCreated={(map) => {
                  map.locate({ setView: true, enableHighAccuracy: true, maxZoom: 14 })
                  map.dragging.disable()
                }}
                attributionControl={false}
                keyboard={false}
                withMapControls={false}
                withMapSearch={false}
                mapHeight={280}
              />
            )
          }
        </div>
      </Href>
    </div>
  )
}

export default TransportBlock